import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/topic-details.mapper";
import * as i2 from "../data.requirements";
export class TopicDetailsUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run(topicId) {
        return this.data.getTopicDetails(topicId).pipe(this.mapper.map);
    }
}
TopicDetailsUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TopicDetailsUseCase_Factory() { return new TopicDetailsUseCase(i0.ɵɵinject(i1.TopicDetailsMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: TopicDetailsUseCase, providedIn: "root" });
